export type DevicePlatform = 'android' | 'ios' | 'other';

export interface DeviceInfo {
  platform: DevicePlatform;
  isMobileOrTablet: boolean;
  model: string; // e.g. "Android - Pixel 6" or "iPad"
  isFirefox: boolean //since screen orienation lock/unlock not supported in firefox browsers
}

// Cache the result to avoid recomputing device info on every call.
// This ensures consistent behavior and improves performance across re-renders or multiple component calls.
let cachedDeviceInfo: DeviceInfo | null = null;

export function getCachedDeviceInfo(): DeviceInfo {
  if (cachedDeviceInfo) return cachedDeviceInfo;

  const userAgent = navigator.userAgent;
  const maxTouchPoints = navigator.maxTouchPoints || 0;
  // Detect platform
  const isAndroid = /android/i.test(userAgent);
  const isIPhone = /iphone/i.test(userAgent);
  const isIPadClassic = /iPad/i.test(userAgent);
  const isModernIpad =
    userAgent.includes("Mac") && maxTouchPoints > 1 && "ontouchend" in document;

  const isIOS = isIPhone || isIPadClassic || isModernIpad;
  const platform: DevicePlatform = isAndroid ? 'android' : isIOS ? 'ios' : 'other';

  // Detect Firefox browser
  const isFirefox = /firefox/i.test(userAgent);

  // Determine if it's mobile or tablet
  const isMobileOrTabletUA = /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
  const isMobileOrTablet = isMobileOrTabletUA || isModernIpad;

  // Parse model
  let model = '.'; //Unknown device. Phone model is used as parameter called Device when we submit the checks to API.

  if (isAndroid) {
    const match = userAgent.match(/Android.*;\s([^)]+)\)/i);
    const deviceModel = match ? match[1].split(' Build')[0].trim() : '';
    model = deviceModel ? `Android - ${deviceModel}` : 'Android';
  } else if (isIPhone) {
    model = 'iPhone';
  } else if (isIPadClassic || isModernIpad) {
    model = 'iPad';
  }
  cachedDeviceInfo = {
    platform,
    isMobileOrTablet,
    model,
    isFirefox
  };
  return cachedDeviceInfo;
}
